import ResponsiveImage from '@expo/react-native-responsive-image';
import { Animated } from 'react-native';
import styled from 'styled-components/native';

import PureImage from '../../../Image/PureImage';

export default {
  Image: styled(PureImage)`
    width: 100%;
    height: 100%;
    position: absolute;
  `,
  ResponsiveImage: styled(ResponsiveImage)`
    width: 100%;
    height: 100%;
    position: absolute;
  `,
  FadingView: styled(Animated.View)`
    width: 100%;
    height: 100%;
    position: absolute;
  `,
};
